import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { pdfjs } from 'react-pdf';
import { useSelector } from 'react-redux';

import { returnPdf, getDocAssigment } from '../../../common/services/http/documentsService';
import Main from '../../layout/main/main';
import PdfViewer from '../pdfViewer/pdfViewer';
import ComponentLoader from '../loaders/componentLoader/componentLoader';
import { RootState } from '../../../redux/store';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IId {
  id: number;
}

interface IFile {
  uint8: string;
  blob: string;
}

interface IDocument {
  label?: string;
}

const PdfPage: React.FC = () => {
  const [file, setFile] = useState<IFile>({ uint8: '', blob: '' });
  const [loading, setLoading] = useState(true);
  const [document, setDocument] = useState<IDocument>({ label: '' });

  // @ts-ignore
  let { assignId } = useParams<IId>();
  const impersonate = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    getDocAssigment(assignId)
      .then((res) => {
        returnPdf(`/Documents/Download/${res.data.documentId}`)
          .then((e: any) => {
            setFile(e);
            setLoading(false);
          })
          .catch((err) => {
            console.log('ERROR: ', err);
            setLoading(false);
          });
        setDocument(res.data);
      })
      .catch((err) => {
        console.log('ERROR: ', err);
        setLoading(false);
      });
  }, [impersonate]);

  return (
    <Main>
      {loading ? (
        <ComponentLoader />
      ) : (
        <PdfViewer
          shouldPin={true}
          id={assignId}
          loading={loading}
          file={file}
          returnPath={'/documents'}
          document={document}
          title={true}
          controlsBcgColor={'$mainBg'}
        />
      )}
    </Main>
  );
};

export default PdfPage;
